import { isGuest } from "$ACTIONS/helper";
import { message } from "antd";
import Router from "next/router";
import { openCpModal } from "../../../store/centralPaymentSlice";

export const handleDepositClick = (dispatch, useCentralPayment) => {
  if (useCentralPayment) {
    if (isGuest()) { // guest mode will not initial global.HasLoggedSelfExclusionTrait object
      // open new deposit2025
      dispatch(openCpModal('deposit')); // TODO: should Guest be able to open deposit??
      return;
    }
    if (typeof global.HasLoggedSelfExclusionTrait?.checkSelfExclusion!=='function') { // do not block opening deposit to avoid trigger P2
      message.error("error: HasLoggedSelfExclusionTrait does not loaded");
      // open new deposit2025
      dispatch(openCpModal('deposit'));
      return;
    }
    global.HasLoggedSelfExclusionTrait.checkSelfExclusion(global.HasLoggedSelfExclusionTrait.depositRestrictionKey).then(selfexclusionRes=>{
        if (selfexclusionRes[0]) {
            return;
        }
    // open new deposit2025
    dispatch(openCpModal('deposit'));
    });
  } else {
    Router.push('/deposit');
  }
};

export const handleWithdrawalClick = (dispatch, useCentralPayment) => {
  if (useCentralPayment) {
    dispatch(openCpModal('withdrawal'));
  } else {
    Router.push('/withdrawal');
  }
};